import React, { FC, PropsWithChildren } from "react";

import { useTranslation } from "react-i18next";
import { IconButton, Stack } from "@mui/material";

import { EditPencil } from "@/assets/icons";
import { StyledCardTitle, StyledGrayCard } from "@/styles/components";

export type GrayCardProps = {
    onEdit: () => void;
};

interface GrayCardType extends GrayCardProps {
    title: string | React.ReactElement;
}

const GrayCard: FC<PropsWithChildren<GrayCardType>> = ({ title, children, onEdit }) => {
    const { t } = useTranslation();

    return (
        <StyledGrayCard className="mt16">
            <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="start"
                marginBottom={{ sm: "16px", xs: "8px" }}
            >
                <StyledCardTitle>{title}</StyledCardTitle>
                <IconButton onClick={onEdit} size="large" aria-label={t("Common.Edit")}>
                    <EditPencil />
                </IconButton>
            </Stack>
            {children}
        </StyledGrayCard>
    );
};

export default GrayCard;
